import { layout } from '../tokens';

/** MUI Paper override — matches card radius design system, flat shadow. */
const MuiPaper = {
  styleOverrides: {
    root: {
      borderRadius: layout.cardRadius,
      boxShadow: 'none',
    },
    rounded: {
      borderRadius: layout.cardRadius,
    },
  },
};

export default MuiPaper;
